import { baseApi } from "@/redux/api/baseApi";

const actorSelectionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSelectedActors: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/actor-selection/get-selected-actors/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["actorSelection"],
    }),
    getRelevantActors: builder.query({
      query: ({ orderId, videoId, page, limit }) => ({
        url: `/actor-selection/get-relevant-actors`,
        method: "GET",
        params: {
          orderId,
          videoId,
          page,
        },
      }),
      providesTags: ["actorSelection"],
    }),

    selectActor: builder.mutation({
      query: ({ order_id, video_id, actor_id }) => ({
        url: `/actor-selection`,
        method: "POST",
        params: {
          order_id,
          video_id,
          actor_id,
        },
      }),
      invalidatesTags: ["actorSelection"],
    }),
    requestActor: builder.mutation({
      query: (payload) => ({
        url: `/request-actor`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["actorSelection","requestedActor"],
    }),
    getRequestedActorDetails: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/request-actor/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["requestedActor"],
    }),
    reOrderActors: builder.mutation({
      query: ({order_id, video_id, data}) => ({
        url: `/actor-selection/reorder-actors/${order_id}/${video_id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["actorSelection"],
    }),
    deSelectActor: builder.mutation({
      query: ({order_id, video_id, actor_id}) => ({
        url: `/actor-selection/deselect-actor/${order_id}/${video_id}/${actor_id}`,
        method: "POST",
      }),
      invalidatesTags: ["actorSelection"],
    }),
    submitSelectedActor: builder.mutation({
      query: ({order_id, video_id}) => ({
        url: `/actor-selection/submit-selected-actor/${order_id}/${video_id}`,
        method: "POST",
      }),
      invalidatesTags: ["actorSelection"],
    }),
    reqActorSelectionTimeLineExtension: builder.mutation({
      query: ({ orderId, videoId, body }) => ({
        url: `/actor-selection/request-an-extension/${orderId}/${videoId}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["actorSelection"],
    }),
    getAssignedActor: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/assign-actor/${orderId}/${videoId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useRequestActorMutation,
  useGetSelectedActorsQuery,
  useGetRelevantActorsQuery,
  useSelectActorMutation,
  useReOrderActorsMutation,
  useDeSelectActorMutation,
  useGetRequestedActorDetailsQuery,
  useSubmitSelectedActorMutation,
  useReqActorSelectionTimeLineExtensionMutation,
  useGetAssignedActorQuery,
} = actorSelectionApi;
